/**
 * A single entry in the user's page/item interaction history.
 * One entry per distinct page or item (keyed by route), updated in place on re-visit.
 */
export interface HistoryEntry {
  /** Unique key for the entry (the tab id / route path) */
  id: string;
  /** Translation key for the page title */
  title: string;
  /** Full navigable route (used to re-open the page) */
  route: string;
  /** Optional icon class (e.g. 'bi bi-person-vcard') */
  icon?: string;
  /** Parent section key (e.g. 'patients', 'analyze') */
  section?: string;
  /** Route parameters, including 'displayName'/'email'/'id' for human-readable labels */
  params?: Record<string, string>;
  /** Whether the entry was a parent page or a child/detail item */
  level: 'parent' | 'child';
  /** Timestamp (ms) of the most recent interaction */
  openedAt: number;
  /** Number of times the user has opened/visited this page */
  visitCount: number;
}

/**
 * Shape persisted to localStorage.
 */
export interface HistoryPersistenceState {
  entries: HistoryEntry[];
  savedAt: number;
}

/** localStorage key for the interaction history */
export const PAGE_HISTORY_STORAGE_KEY = 'mdi_page_history';

/** Maximum number of entries kept in history */
export const PAGE_HISTORY_MAX_ENTRIES = 50;
